import { render } from "./PaymentMethodReturn.vue?vue&type=template&id=68d8b13c&scoped=true"
import script from "./PaymentMethodReturn.vue?vue&type=script&lang=js"
export * from "./PaymentMethodReturn.vue?vue&type=script&lang=js"

import "./PaymentMethodReturn.vue?vue&type=style&index=0&id=68d8b13c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d8b13c"]])

export default __exports__